import {withDevtools} from '@angular-architects/ngrx-toolkit';
import {patchState, signalStore, withMethods, withState} from '@ngrx/signals';

import {Layout, SortingStrategyId, TileDisplay} from '@selpia/shared/models';

import {OptionsState} from '../models/optionsstate.model';

const initialOptionsState: OptionsState = {
  focusPeriod: undefined,
  focusMeasure: undefined,
  sortType: SortingStrategyId.AlphabeticAsc,
  layout: Layout.Grid,
  tileDisplay: TileDisplay.Trends,
  colouringStrategy: undefined,
};

export const OptionsStore = signalStore(
  {providedIn: 'root'},
  withDevtools('options-store'),
  withState(initialOptionsState),
  withMethods((store) => ({
    setOptions(options: Partial<OptionsState>): void {
      patchState(store, options);
    },
  })),
);

export type OptionsStore = InstanceType<typeof OptionsStore>;
